import React from 'react';  
import LineworxClient from '../lineworxClient';
import 'react-dropdown/style.css'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { CSSTransition } from 'react-transition-group';
import Section from '../components/Section/Section';

// Import module css
import styles from './User.module.css';

class User extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      companyName: '',
      error: false,
      email: '',
      fname: '',
      joinDate: null,
      // joinDate: '01/01/2021',
      lname: '',
      loading: false,
      password: '',
      phone: '',
      showForgot: false,
      updating: 0,
      forgotEmail:'',
    }
    
    this.forgotPassword = this.forgotPassword.bind(this);
    this.handleCompanyName = this.handleCompanyName.bind(this);
    this.handleEmailAddress = this.handleEmailAddress.bind(this);
    this.handleFirstName = this.handleFirstName.bind(this);
    this.handleLastName = this.handleLastName.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.logout  = this.logout.bind(this);
    // this.showJoinDateCalendar = this.showJoinDateCalendar.bind(this);
    this.toggleForgot = this.toggleForgot.bind(this);
    this.toggleJoinDateCalendar = this.toggleJoinDateCalendar.bind(this);
    this.hideJoinDateCalendar = this.hideJoinDateCalendar.bind(this);
    this.saveData = this.saveData.bind(this);
    this.changeForgotEmail = this.changeForgotEmail.bind(this);
  }
  
  async changeForgotEmail(email) {
    console.log(email.target.value);
    this.setState({
        forgotEmail:email.target.value
    });
  }

  componentDidMount() {
    this.getUserData();
  }

  async saveData() {
    this.setState(prevState => ({
        loading: true
      }))

      const user = {
        email:this.state.email,
        first_name:this.state.fname,
        last_name:this.state.lname,
        phone_number:this.state.phone_number
      }  
    
      let response = await LineworxClient.saveUserDetails(user);    

      this.setState(prevState => ({
        loading: false,
        save_error: response.body.success === true ? false : true,
        save_success: response.body.success === true ? true : false
      }));

      setTimeout(() => {this.setState({
        save_error: false,
        save_success: false
      })}, 5000);

      

  }

  async getUserData() {
    this.setState(prevState => ({
        loading: true
      }))
  
      const data = await LineworxClient.getMyUserData();
      if(data.body && data.body.length > 0) {
        
        let user = data.body[0];
        this.setState({
            companyName: user.company_name,
            error: false,
            email: user.email == null ? '' : user.email,
            forgotEmail:user.email == null? '' : user.email,
            fname: user.first_name,
            joinDate: user.created_date,
            lname: user.last_name,
            loading: false,
            password: '',
            phone_number: user.phone_number == null ? '' : user.phone_number,
            showForgot: false,
            updating: 0
        });

      } else {
        this.setState(prevState => ({
          loading: false,
          error:true
        }));
      }
  }

  async logout() {
    LineworxClient.logout();
    window.location.href='/login';
    //this.props.history.push('/login');
  }

  async toggleForgot() {
    this.setState({
      showForgot: !this.state.showForgot,
    })
  }

  async forgotPassword(e) {
    if(this.state.email.length < 2) {
      this.setState({ error: true });
      return
    }
    
    this.setState({ loading: true });
    console.log(`Email to use: ${this.state.forgotEmail}`);
    let resp = await LineworxClient.forgotPassword(this.state.forgotEmail);
    this.setState({ loading: false });
    this.toggleForgot(null);
    // console.log(resp);
    alert("Check your email for a link to reset your password");
  };

  handleFirstName(e) {
    this.setState({
      fname: e.target.value,
    })
  }

  handleLastName(e) {
    this.setState({
      lname: e.target.value,
    })
  }

  handleEmailAddress(e) {
    this.setState({
      email: e.target.value,
    })
  }

  handlePhone(e) {

    this.setState({
      phone_number: e.target.value,
    })
  }

  handleCompanyName(e) {
    this.setState({
      companyName: e.target.value,
    })
  }

  toggleJoinDateCalendar() {
    this.setState({
      showJoinDateCalendar: !this.state.showJoinDateCalendar
    })
  }

  hideJoinDateCalendar() {
    this.setState({
      showJoinDateCalendar: false,
    })
  }

  
  render() {
    const {
      fname,
      lname,
      email,
      phone_number,
      joinDate,
      companyName,
    } = this.state;

    let joinDateFormatted = new Intl.DateTimeFormat('en').format(joinDate);
    console.log(joinDateFormatted)
    //let  = ((joinDate.getMonth() > 8) ? (joinDate.getMonth() + 1) : ('0' + (joinDate.getMonth() + 1))) + '/' + ((joinDate.getDate() > 9) ? joinDate.getDate() : ('0' + joinDate.getDate())) + '/' + joinDate.getFullYear();

    return (
      <div className="container-fluid px-0">
      <div
        className="loader-wrapper"
        hidden={this.state.updating === 0} />
      
      <CSSTransition
        in={this.state.updating > 0}
        timeout={400}
        key={"loaderkey"}
        classNames="alert"
        unmountOnExit
      >
        <div className="loader"></div>
      </CSSTransition>
        
        {/* section - Page Header */}
        <Section>
          <div className="col py-5">
            <h1 className={styles.pageTitle}>User Account</h1>
          </div>
        </Section>

        
        {/* section - User Info */}
        <Section>
          <div className="col pt-5 pb-0 pt-sm-0 pb-sm-5">

            <div className="row flex-column flex-sm-row">
              <div className={`col-sm-7 col-md-9 offset-sm-1 ${styles.formItems}`}>
                <div 
                  className={`save-success alert alert-success`}
                  style={{display: this.state.save_success ? 'block' : 'none', position: 'absolute', width: '100%'}}
                >
                  Success! Your changes were saved.
                </div>
                <div 
                  className={`save-success alert alert-danger`}
                  style={{display: this.state.save_error ? 'block' : 'none', position: 'absolute', width: '100%'}}

                >
                  There was an error saving your data. Please try again!
                </div>
                {/* section - First / Last Name */}
                <div className={`row flex-column flex-md-row mx-0 ${styles.section}`}>
                  
                  {/* item - First Name */}
                  <div className={`col-md-6 pr-md-4 ${styles.item} fName`}>
                    <label
                      className={`${styles.labelTitle} ${styles.lg}`}
                      htmlFor="fName"
                    >
                      First Name
                    </label>
                    <input
                      className={styles.inputText}
                      value={fname}
                      type="text"
                      name="fName"
                      id="fName"
                      onChange={this.handleFirstName} />
                  </div>

                  {/* item - Last Name */}
                  <div className={`col-md-6 pl-md-4 ${styles.item} lName`}>
                    <label
                      className={`${styles.labelTitle} ${styles.lg}`}
                      htmlFor="lName"
                    >
                      Last Name
                    </label>
                    <input
                      className={styles.inputText}
                      value={lname}
                      type="text"
                      name="lName"
                      id="lName"
                      onChange={this.handleLastName} />
                  </div>
                </div>

                {/* section - Email / Phone */}
                <div className={`row flex-column flex-md-row mx-0 ${styles.section}`}>

                  {/* item - email */}
                  <div className={`col-md-6 pr-md-4 ${styles.item} email`}>
                    <label
                      className={`${styles.labelTitle} ${styles.lg}`}
                      htmlFor="email"
                    >
                      Email Address
                    </label>
                    <input
                      className={styles.inputText}
                      value={email}
                      type="text"
                      name="email"
                      id="email"
                      onChange={this.handleEmailAddress} />
                  </div>

                  {/* item - phone */}
                  <div className={`col-md-6 pl-md-4 ${styles.item} phone`}>
                    <label
                      className={`${styles.labelTitle} ${styles.lg}`}
                      htmlFor="phone"
                    >
                      Phone
                    </label>
                    <input
                      className={styles.inputText}
                      defaultValue={phone_number}
                      type="text"
                      name="phone"
                      id="phone"
                      onChange={this.handlePhone} />
                  </div>

                </div>

                {/* section - Join Date / Company Name */}
                <div className={`row flex-column flex-md-row mx-0 ${styles.section}`}>

                  {/* item - Join Date */}
                  {/* <div className={`col-md-6 pr-md-4 ${styles.item} joinDate`}>
                    <label
                      className={`${styles.labelTitle} ${styles.lg}`}
                      htmlFor="joinDate"
                    >
                      Join Date
                    </label>
                    <input
                      className={styles.inputText}
                      value={joinDate}
                      type="text"
                      name="joinDate"
                      id="joinDate" />
                  </div> */}
                  <div className={`col-md-6 pr-md-4 ${styles.item} joinDate`}>
                    <label
                      className={`${styles.labelTitle} ${styles.lg}`}
                      htmlFor="joinDate"
                    >
                      Join Date 
                    </label>

                    <input
                      className={`${styles.inputText} ${styles.dateInput}`}
                      value={joinDateFormatted}
                      type="text"
                      name="joinDate"
                      id="joinDate"
                      data-id={joinDateFormatted}
                      readOnly
                    />
                      
                    {/* <div
                      hidden={!this.state.showJoinDateCalendar}
                      className="dateCalendar"
                    >
                      <Calendar
                        onChange={this.onJoinDateChange}
                        value={this.state.joinDate}
                        className={"modal-calendar"} />
                    </div> */}
                  </div>

                  {/* item - Company Name */}
                  <div className={`col-md-6 pl-md-4 ${styles.item} companyName`}>
                    <label
                      className={`${styles.labelTitle} ${styles.lg}`}
                      htmlFor="companyName"
                    >
                      Company Name
                    </label>
                    <input
                      className={styles.inputText}
                      defaultValue={companyName}
                      type="text"
                      name="companyName"
                      id="companyName"
                      readOnly/>
                  </div>

                </div>
                
              </div>
              
              <div className={`col-sm-4 col-md-2 mt-5 mt-sm-0 ${styles.btns}`}>
                <button
                  type="button"
                  className={`btn btn-t mb-4 w-100`}
                  onClick={this.toggleForgot}
                >
                  Reset Password
                </button>

                <button
                  type="button"
                  className={`btn btn-warning w-100 d-flex text-center`}
                  onClick={this.logout}
                >                  
                  <span>Logout</span>
                </button>
              </div>
            </div>

          </div>
        </Section>
          
        {/* section - Btn Action */}
        <Section>
          <div className="col pt-4">
            {/* <div className="btn-action d-flex justify-content-end text-right" onClick={()=> {this.props.history.replace('/job')}}> */}
            <div className={`${styles.btnAction} d-flex justify-content-end ml-sm-auto text-right`}>
              <button
                type="button"
                onClick={this.saveData}
                className={`btn btn-primary d-flex text-center ${styles.btnIcon}`}
              >
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 4H11V7L7 7V11H4V7L0 7V4.04102H4V0H7V4Z"
                    fill="white" />
                </svg>
                
                <span>Save</span>
              </button>
            </div>
          </div>
        </Section>

        
        {/* <div className="container-fluid section">
          <div className="date-section d-flex justify-content-between mt-5">
            <div className="right">
              <button type="button" className="btn btn-warning btn-mw150 text-white " style={{marginTop:"25px",marginLeft:"20px"}} onClick={this.logout}>
                <div className="d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-plus"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                  
                  <span>Logout</span>
                </div>
              </button>
            </div>
          </div>
        </div> */}
                
        {this.state.showForgot &&
          <div id="pwdModal" className={`modal ${styles.modalPwd}`} style={{display:"unset"}} tabIndex="-1" role="dialog" >
            <div className={`modal-dialog modal-lg modal-dialog-centered ${styles.modalDialog}`}>
              <div className="modal-content">
                <fieldset>

                  {/* MODAL HEADER */}
                  <div className={`modal-header ${styles.modalHeader}`}>
                    <h5 className={`modal-title text-center ${styles.modalTitle}`}>What&apos;s My Password?</h5>
                    <button type="button" className={`close ${styles.modalHeaderClose}`} onClick={this.toggleForgot} aria-hidden="true" />
                  </div>
                
                  {/* MODAL BODY */}
                  <div className={`modal-body ${styles.modalBody}`}>
                    <div className="col-md-12">
                      <div className="panel panel-default">
                        <div className="panel-body">
                          <div className="text-center">
                            <p className={styles.modalBodyDirections}>If you have forgotten your password you can reset it here.</p>
                            
                            <div className="panel-body">
                              <div className={`form-group ${styles.modalBodyFormGroup}`}>
                                <input
                                  className={`form-control input-lg ${styles.modalBodyInput}`}
                                  placeholder="E-mail Address"
                                  name="email"
                                  type="email"
                                  value={this.state.forgotEmail}
                                  onChange={this.changeForgotEmail} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* MODAL FOOTER */}
                  <div className={`modal-footer b-0 ${styles.modalFooter}`}>
                    <div className="row m-0 w-100">
                      <div className="col-md-12 d-flex flex-column flex-sm-row justify-content-sm-end">
                        <button
                          className={`btn btn-secondary mb-3 mb-sm-0 ${styles.modalFooterButton}`}
                          data-dismiss="modal"
                          aria-hidden="true"
                          onClick={this.toggleForgot}
                        >
                          Cancel
                        </button>

                        <input
                          className={`btn btn-lg btn-primary btn-block my-0 ml-0 ml-sm-4 mr-0 ${styles.modalFooterButton} ${styles.modalFooterSubmit}`}
                          value="Send My Password"
                          type="submit"
                          onClick={this.forgotPassword} />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        }

      </div>
    );
  }
}

export default User
